(function () {
  const galleryWrapperSelector = '.product__images';
  const teeGallerySelector = '#tee-gallery.tee-gallery-content, #tee-gallery';
  const teeFormSelector = '#tee-artwork-form, .teeinblue-item--product';
  const stickyClass = 'gallery--sticky';
  const hiddenClass = 'gallery--sticky--hide';
  const galleryActiveClass = 'sticky-image-gallery';
  const stickyButtonClass = 'sticky-gallery-button';
  const closeButtonClass = 'gallery--close-button';
  const previewButtonSelector = '.tee-btn--preview';
  const previewModalSelector = '.vm--modal.tee-dialog-gallery, .tee-dialog-gallery .vm--modal';
  const mobilePopupStateEvent = 'pawuni:mobile-popup-state-change';
  const previewCloseSelector = [
    '.vm--modal.tee-dialog-gallery .tee-dialog-close',
    '.vm--modal.tee-dialog-gallery .vm--close',
    '.vm--modal.tee-dialog-gallery .tee-dcontent-footer .tee-btn',
    '.tee-dialog-gallery .vm--modal .tee-dialog-close',
    '.tee-dialog-gallery .vm--modal .vm--close',
    '.tee-dialog-gallery .vm--modal .tee-dcontent-footer .tee-btn',
    '.vm--container.tee-dialog-gallery .vm--overlay',
    '.tee-dialog-gallery .vm--overlay',
  ].join(', ');

  let stickySuspendedUntil = 0;
  // Keep the PDP form from shifting behind TeeInBlue's preview modal while sticky resumes.
  let preserveStickyPlaceholder = false;
  let resumeTimer = 0;
  let ticking = false;

  const isPortraitPhone = () => {
    const width = window.innerWidth || document.documentElement.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight;

    return width < 768 && height / Math.max(width, 1) > 1.5;
  };

  const getStickyPreviewHeight = () => {
    const width = window.innerWidth || document.documentElement.clientWidth;
    return Math.min(Math.max(width * 0.72, 260), 360);
  };

  const getNodes = () => {
    const galleryWrapper = document.querySelector(galleryWrapperSelector);
    const teeGallery = galleryWrapper ? galleryWrapper.querySelector(teeGallerySelector) : null;
    const teeForm = document.querySelector(teeFormSelector);

    return {
      galleryWrapper,
      teeForm,
      teeGallery,
    };
  };

  const isRendered = (element) => {
    if (!(element instanceof Element)) {
      return false;
    }

    const rect = element.getBoundingClientRect();

    if (rect.width <= 0 || rect.height <= 0) {
      return false;
    }

    let current = element;

    while (current && current !== document.documentElement) {
      const style = window.getComputedStyle(current);

      if (
        current.hidden ||
        current.getAttribute('aria-hidden') === 'true' ||
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.opacity === '0'
      ) {
        return false;
      }

      current = current.parentElement;
    }

    return true;
  };

  const isPreviewPopupOpen = () =>
    Array.from(document.querySelectorAll(previewModalSelector)).some((modal) => isRendered(modal));

  const isStickySuspended = () => window.performance.now() < stickySuspendedUntil;

  const setStickyPlaceholderHeight = (nodes) => {
    if (!nodes || !nodes.galleryWrapper || !isPortraitPhone()) {
      return;
    }

    nodes.galleryWrapper.style.height = `${getStickyPreviewHeight() + 10}px`;
  };

  const scheduleUpdateBurst = () => {
    [0, 180, 420, 900, 1600, 2600, 4200].forEach((delay) => {
      window.setTimeout(scheduleUpdate, delay);
    });
  };

  const scheduleStickyResume = (delay = 320) => {
    if (resumeTimer) {
      window.clearTimeout(resumeTimer);
    }

    stickySuspendedUntil = Math.max(stickySuspendedUntil, window.performance.now() + delay);
    resumeTimer = window.setTimeout(() => {
      resumeTimer = 0;
      stickySuspendedUntil = 0;
      scheduleUpdateBurst();
    }, delay);
  };

  const cancelStickyResume = () => {
    if (!resumeTimer) {
      return;
    }

    window.clearTimeout(resumeTimer);
    resumeTimer = 0;
  };

  const clearStickyState = (nodes, options = {}) => {
    const preserveHeight = Boolean(options.preserveHeight);

    if (!preserveHeight) {
      preserveStickyPlaceholder = false;
    }

    document.body.classList.remove(stickyClass, hiddenClass);

    if (nodes && nodes.galleryWrapper) {
      if (preserveHeight) {
        setStickyPlaceholderHeight(nodes);
      } else {
        nodes.galleryWrapper.style.removeProperty('height');
      }
    }

    if (nodes && nodes.teeGallery) {
      nodes.teeGallery.classList.remove(galleryActiveClass);
    }
  };

  const ensureStickyButton = () => {
    let stickyButton = document.querySelector(`.${stickyButtonClass}`);

    if (stickyButton) {
      return stickyButton;
    }

    stickyButton = document.createElement('button');
    stickyButton.type = 'button';
    stickyButton.className = stickyButtonClass;
    stickyButton.setAttribute('aria-label', 'Show product preview');
    stickyButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      document.body.classList.remove(hiddenClass);
      scheduleUpdate();
    });
    document.body.appendChild(stickyButton);

    return stickyButton;
  };

  const ensureCloseButton = (teeGallery) => {
    if (!teeGallery || teeGallery.querySelector(`:scope > .${closeButtonClass}`)) {
      return;
    }

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = closeButtonClass;
    closeButton.setAttribute('aria-label', 'Hide product preview');
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      document.body.classList.add(hiddenClass);
      const nodes = getNodes();
      if (nodes.galleryWrapper) {
        nodes.galleryWrapper.style.removeProperty('height');
      }
    });
    teeGallery.appendChild(closeButton);
  };

  const updateStickyPreview = () => {
    const nodes = getNodes();

    if (!isPortraitPhone()) {
      clearStickyState(nodes);
      return;
    }

    if (isStickySuspended() || isPreviewPopupOpen()) {
      clearStickyState(nodes, { preserveHeight: preserveStickyPlaceholder });
      return;
    }

    if (!nodes.galleryWrapper || !nodes.teeGallery || !nodes.teeForm) {
      clearStickyState(nodes);
      return;
    }

    ensureStickyButton();
    ensureCloseButton(nodes.teeGallery);

    const galleryTop = nodes.galleryWrapper.getBoundingClientRect().top;
    const teeFormBottom = nodes.teeForm.getBoundingClientRect().bottom;
    const stickyPreviewHeight = getStickyPreviewHeight();
    const shouldStick = galleryTop < -10 && teeFormBottom > stickyPreviewHeight + 20;

    if (!shouldStick) {
      clearStickyState(nodes);
      return;
    }

    if (document.body.classList.contains(hiddenClass)) {
      preserveStickyPlaceholder = false;
      nodes.galleryWrapper.style.removeProperty('height');
      return;
    }

    setStickyPlaceholderHeight(nodes);
    document.body.classList.add(stickyClass);
    nodes.teeGallery.classList.add(galleryActiveClass);
    preserveStickyPlaceholder = false;
  };

  function scheduleUpdate() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(() => {
      ticking = false;
      updateStickyPreview();
    });
  }

  const initStickyPreview = () => {
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('orientationchange', scheduleUpdate);
    document.addEventListener('input', scheduleUpdate, true);
    document.addEventListener('change', scheduleUpdate, true);
    document.addEventListener('teeinblue-event-component-injected', scheduleUpdate);
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;

        if (!(target instanceof Element) || !target.closest(previewButtonSelector)) {
          return;
        }

        const nodes = getNodes();
        preserveStickyPlaceholder =
          document.body.classList.contains(stickyClass) && !document.body.classList.contains(hiddenClass);

        cancelStickyResume();
        clearStickyState(nodes, { preserveHeight: preserveStickyPlaceholder });
        stickySuspendedUntil = Math.max(stickySuspendedUntil, window.performance.now() + 5000);
        window.setTimeout(scheduleUpdate, 400);
        window.setTimeout(scheduleUpdate, 1200);
        window.setTimeout(scheduleUpdate, 5200);
      },
      true,
    );
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;

        if (!(target instanceof Element) || !target.closest(previewCloseSelector)) {
          return;
        }

        scheduleStickyResume(360);
      },
      true,
    );
    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Escape' || (!isStickySuspended() && !isPreviewPopupOpen())) {
          return;
        }

        scheduleStickyResume(360);
      },
      true,
    );
    document.addEventListener(mobilePopupStateEvent, (event) => {
      if (event.detail && event.detail.open === false) {
        scheduleStickyResume(160);
      }
    });

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden'],
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => observer.disconnect(), 15000);
    window.setTimeout(scheduleUpdate, 250);
    window.setTimeout(scheduleUpdate, 1000);
    window.setTimeout(scheduleUpdate, 2500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyPreview);
  } else {
    initStickyPreview();
  }
})();
